import generateActions from 'utils/actions';

export const TOGGLE = 'search/TOGGLE';
export const SEARCH_SONGS = generateActions('search/SEARCH_SONGS');
export const SEARCH_ALBUMS = generateActions('search/SEARCH_ALBUMS');
export const SEARCH_ARTISTS = generateActions('search/SEARCH_ARTISTS');

/**
 * Toggle the search modal
 */
export function toggleSearch() {
  return {
    type: TOGGLE,
  };
}

/**
 * Search for published songs
 * @param {String} query 
 */
export function searchSongs(query) {
  return {
    types: SEARCH_SONGS,
    promise: {
      url: `/search/songs`,
      data: { query },
    },
  };
}

/**
 * Search for published albums
 * @param {String} query 
 */
export function searchAlbums(query) {
  return {
    types: SEARCH_ALBUMS,
    promise: {
      url: `/search/albums`,
      data: { query },
    },
  };
}

/**
 * Search for artists with published content
 * @param {String} query 
 */
export function searchArtists(query) {
  return {
    types: SEARCH_ARTISTS,
    promise: {
      url: `/search/artists`,
      data: { query },
    },
  };
}

/**
 * Search songs, albums and artists at the same time
 * @param {String} query 
 */
export function search(query) {
  return (dispatch) => {
    const all = [];
    all.push(dispatch(searchSongs(query)));
    all.push(dispatch(searchAlbums(query)));
    all.push(dispatch(searchArtists(query)));

    return Promise.all(all);
  };
}
